import { useFeatureFlagEnabled } from '@frameio/feature-flags';
import type { AccountTier } from '@frameio/graphql-client/generated';
import {
  useAccountTierFieldsFragment,
  useAccountTrialStatusFragment,
} from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '../../contexts';

// Tiers that qualify for the retail mounted storage flag check.
// Extend this array as additional retail tiers are introduced.
const RETAIL_TIERS: AccountTier[] = ['PRO', 'TEAM'];

export const useIsMountableStorageEnabled = (): boolean => {
  const accountId = useActiveAccountId();
  const { data: account } = useAccountTierFieldsFragment(accountId);
  const { data: accountTrialStatus } = useAccountTrialStatusFragment(accountId);

  const isMountableStorageFlagEnabled = useFeatureFlagEnabled(
    'v4.mountable_storage'
  );

  const tier = account?.tier;
  const isPaidTier = tier != null && RETAIL_TIERS.includes(tier);
  const isTrialActive =
    accountTrialStatus?.subscription?.trial?.isActive === true;

  return isMountableStorageFlagEnabled || (isPaidTier && !isTrialActive);
};
